import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CourseList from "./CourseList";
import { Link } from "react-router-dom";
import Menu from "../common/Menu";
import isVisible from "../../common-functions/isVisible"
import getPrivileges from "../../common-functions/getPrivileges"


class Courses extends Component {
  render() {
    const {
			auth
		} = this.props
		const privileges = getPrivileges(auth);
    const isShow = privileges && isVisible(privileges, "courses")
    const isAdd = privileges && isVisible(privileges, "courses", "create")
    return (
      <div className="wrapper">
        <Menu />
        {!isShow && <div className="p-5" />}
        {isShow && <div className="container">
          <div className="d-flex justify-content-between mt-3 mb-3">
            <div>
              <h1>Courses</h1>
            </div>

            <div>
              {isAdd && <Link to="/admin/dashboard/courses/create" className="btn btn-pp">
                Create a new Course
              </Link>}
            </div>
          </div>

          <div>
            <CourseList />
          </div>
        </div>}
      </div>
    );
  }
}
Courses.propTypes = {};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  {}
)(Courses);
